/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

export enum ActivityLifecycleType {
  RESUMED = 0,
  PAUSED = 1,
  BACKGROUNDED = 2,
  CRASHED = 3,
}
